var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-10 py-5 mt-15",attrs:{"color":"indigo darken-4 "}},[_c('v-card',{staticClass:"pa-0 ma-0 elevation-0"},[_c('v-row',{staticClass:"ma-0"},[_c('v-col',{staticClass:"ma-0 pa-0",attrs:{"md":"3"}},[_c('Sidebar')],1),_c('v-col',{staticClass:"px-10 py-5",attrs:{"md":"9"}},[_vm._v(" Coming Soon. ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }